export default __webpack_public_path__ + "static/media/hacking.ee22bda4.jpg";